import type { JourneyType } from "../../types/journey";
import type { JourneyTypeEnum } from "../../types/onboarding";

// The §4 journeyType enum is coarse; the CDN step catalog uses fine-grained
// patient-facing keys. Map to the default variant for S8. Enums without a
// catalog (dont_know/other) return undefined → S8 auto-skips (spec §8).
const ENUM_TO_CATALOG: Partial<Record<JourneyTypeEnum, JourneyType>> = {
	ivf: "ivf",
	iui: "iui",
	surrogacy: "surrogacy_ip",
	egg_donation: "egg_donation_recipient",
	sperm_donation: "sperm_donation",
	egg_freezing: "egg_freezing",
};

export function journeyEnumToCatalogType(
	value: JourneyTypeEnum | string | undefined,
): JourneyType | undefined {
	if (!value) return undefined;
	return ENUM_TO_CATALOG[value as JourneyTypeEnum];
}

// The catalogs the S8 steps screen should render for a given answer state.
// Two branches skip S7 yet still show steps (FigJam): currently_pregnant →
// pregnancy list; surrogate role → surrogate-branch list. Empty result ⇒ S8
// must be skipped (no catalog to show, e.g. dont_know/other) — otherwise the
// user lands on an empty screen with a disabled Confirm and is trapped.
export function resolveStepCatalogTypes(
	statusEnum: string | undefined,
	roleEnum: string | undefined,
	journeyEnums: string[],
): JourneyType[] {
	if (statusEnum === "currently_pregnant") return ["pregnancy"];
	if (roleEnum === "surrogate") return ["surrogacy_surrogate"];
	return journeyEnums
		.map((j) => journeyEnumToCatalogType(j))
		.filter((c): c is JourneyType => c !== undefined);
}
